var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Тип расходов объекта",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      fields: _vm.fields,
      "route-create": "LocationCostTypeAdd",
      "route-edit": "LocationCostTypeEdit",
      "route-view": "LocationCostTypeView",
      "route-path": "/location_cost_types",
      "can-edit": _vm.canEditLocationCostTypeCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58e3888c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58e3888c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/LocationCostTypes/LocationCostTypes.vue
// module id = null
// module chunks = 